import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function SetupLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { label: "Home",                  icon: "pi pi-home",      path: "/site-setup" },
    { label: "Hero",                  icon: "pi pi-palette",   path: "/site-setup/hero-section" },
    { label: "Coupons (Deprecated)",  icon: "pi pi-lock",      path: "/site-setup/coupons" },
    { label: "Contact Section",       icon: "pi pi-phone",     path: "/site-setup/contact-section" },
    { label: "Order Number Settings", icon: "pi pi-hashtag",   path: "/site-setup/order-number-settings" },
    { label: "Themes",                icon: "pi pi-image",     path: "/site-setup/themes" },
    { label: "Menu",                  icon: "pi pi-list",      path: "/site-setup/menu" },
    { label: "Layout Setup",          icon: "pi pi-th-large",  path: "/site-setup/layout-setup" },
    { label: "New Tab",               icon: "pi pi-file",      path: "/site-setup/new-tab" },
    { label: "Page Layout Management",icon: "pi pi-table",     path: "/site-setup/page-layout-management" },
    { label: "Widgets",               icon: "pi pi-th-large",  path: "/site-setup/widgets" },
  ];

  const isActive = (path) => {
    if (path === "/site-setup") return location.pathname === "/site-setup";
    return location.pathname.startsWith(path);
  };

  return (
    <div>
      <div className="mx-4">
        <div style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "4px",
          padding: "8px",
          background: "#fff",
          border: "1px solid #dee2e6",
          borderRadius: "6px",
        }}>
          {tabs.map((tab) => {
            const active = isActive(tab.path);
            return (
              <button
                key={tab.path}
                onClick={() => navigate(tab.path)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "6px 12px",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: active ? "600" : "400",
                  background: active ? "var(--primary-color, #6366f1)" : "transparent",
                  color: active ? "#fff" : "#495057",
                  transition: "all 0.2s",
                }}
                onMouseEnter={(e) => {
                  if (!active) {
                    e.currentTarget.style.background = "#f0f0f0";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!active) {
                    e.currentTarget.style.background = "transparent";
                  }
                }}
              >
                <i className={tab.icon} style={{ fontSize: "13px" }} />
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>
      <div>{children}</div>
    </div>
  );
}
